import { PARTy } from '../../../model/school.model';
import { User, UserToken } from './../../auth/model/user.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { InputEmailStandaloneService } from './service/input-email-standalone.service';
import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
    selector: 'input-email-standalone',
    templateUrl: './input-email-standalone.component.html',
    styleUrls: ['./input-email-standalone.component.scss']
})
export class InputEmailStandaloneComponent implements OnInit {
    @Input() matLabel: string = 'Email Address';
    @Input() placeholder: string = 'Email Address';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;
    @Input() emailToConfirm: string = '';
    @Output() emailToConfirmChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() onValidatedEmailEvent: EventEmitter<any> = new EventEmitter();

    isLoading: boolean = false;
    msg!: MsgModel;

    myControl: any;
    filteredOptions!: Observable<any>;

    minCharacters: number = 3;
    email: string = '';

    constructor(private inputEmailStandaloneService: InputEmailStandaloneService, private utilityService: UtilityService) {}

    ngOnInit(): void {
        this.myControl = this.form.controls['txtEmailFC']; //controls['txtEmailFC'];//<FormControl>this.form.get(this.controlName);

        /*        this.filteredOptions = this.myControl.valueChanges.pipe(
            // only search if search string is >= 3 characters
            filter((text: string) => text !== null && text.length >= this.minCharacters && this.validateEmail(text, this.myControl)),
            debounceTime(1000),
            distinctUntilChanged(),
            map((value) => this.checkEmail(value))
        );
  */
    }

    @HostListener('window:keyup', ['$event'])
    onKeyDownEmails2(e: any) {
        const pattern = /[A-Za-z\+\-\ ]/;
        // console.log(e.srcElement.id);
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed, onKeyDownNames');
                e.preventDefault();
            }

            if (this.email) {
                this.checkEmail(this.email);
            }
        }
    }

    checkEmail(email: any) {
        this.isLoading = true;
        this.inputEmailStandaloneService
            .checkEmailDomain(email)
            .pipe()
            .subscribe((res) => {
                if (res) {
                    if (res.msg ? res.msg.SUCCESS : false) {
                        let user: UserToken = JSON.parse(localStorage.getItem('userToken') || '{}') || new User();

                        this.inputEmailStandaloneService
                            .emailExists(email, user.user?.PERSON?.PARTy)
                            .pipe()
                            .subscribe((res) => {
                                this.isLoading = false;

                                // Swap success for emailExists
                                // returned value [true === Email already used] => set SUCCESS to false
                                // returned value [false === Email is available] => set SUCCESS to true
                                this.msg = this.swapSuccess(res.msg);
                                this.myControl.setErrors(this.msg.SUCCESS ? null : { emailExists: true });
                            });
                    } else {
                        this.myControl.setErrors({ emailDomain: true });
                        this.msg = res.msg;
                        this.msg.MSG += '. Your email address must be from an education-related domain.';
                        this.isLoading = false;
                    }
                } else {
                    this.myControl.setErrors({ emailDomain: true });
                    this.msg = { MSG: 'The email domain is not valid. Your email address must be from an education-related domain.', SUCCESS: false };
                    this.isLoading = false;
                }
                this.onValidatedEmailEvent.emit(email);

                this.emailToConfirmChange.emit(email);
            });
    }

    validateEmail(email: string, form: UntypedFormControl) {
        console.log('validate email');
        const regularExpression =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const isEmail = regularExpression.test(String(email).toLowerCase());

        this.myControl.setErrors(isEmail ? null : { email: true });
        return isEmail;
    }

    swapSuccess(msg: MsgModel) {
        msg.SUCCESS = !msg.SUCCESS;
        return msg;
    }
}
